import { cn } from '../utils'

const sizeMap = {
  sm: { icon: 24, text: 'text-base' },
  md: { icon: 32, text: 'text-lg' },
  lg: { icon: 40, text: 'text-2xl' },
} as const

export interface IntelliAuthLogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  variant?: 'light' | 'dark' | 'auto'
  className?: string
}

export function IntelliAuthLogo({
  size = 'md',
  showText = true,
  variant = 'auto',
  className,
}: IntelliAuthLogoProps) {
  const { icon, text } = sizeMap[size]

  const textColorClass =
    variant === 'light' ? 'text-white' : variant === 'dark' ? 'text-slate-900' : 'text-foreground'

  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg
        width={icon}
        height={icon}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <defs>
          <linearGradient
            id="ia-shield-grad"
            x1="8"
            y1="4"
            x2="32"
            y2="36"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5B8DEF" />
            <stop offset="1" stopColor="#023ECA" />
          </linearGradient>
          <linearGradient
            id="ia-lock-grad"
            x1="16"
            y1="14"
            x2="24"
            y2="30"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C7DBFE" />
            <stop offset="1" stopColor="#9CBBF7" />
          </linearGradient>
        </defs>
        {/* Shield body */}
        <path
          d="M20 3L6 9v10c0 9.55 5.97 18.48 14 20.5 8.03-2.02 14-10.95 14-20.5V9L20 3z"
          fill="url(#ia-shield-grad)"
        />
        {/* Lock keyhole motif */}
        <circle cx="20" cy="18" r="3.5" fill="url(#ia-lock-grad)" />
        <rect x="18.5" y="20" width="3" height="5" rx="1.5" fill="url(#ia-lock-grad)" />
      </svg>
      {showText && (
        <span className={cn('font-bold tracking-tight', text, textColorClass)}>IntelliAuth</span>
      )}
    </span>
  )
}
